import React from 'react'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import {ContextMenuContext} from './ContextMenu'

type Props<T extends React.ElementType> = Overwrite<
  CommonProps<T>,
  {
    as?: T
    children: React.ReactNode
    onClick?: (event: React.MouseEvent, href: string) => void
    disabled?: boolean
  }
>

const ContextMenuLink = <T extends React.ElementType = 'a'>({
  as,
  className,
  href = '#',
  children,
  onClick,
  disabled = false,
  ...props
}: Props<T>) => {
  const Root = (as ?? 'a') as React.ElementType
  const {onClose, size} = React.useContext(ContextMenuContext)

  const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault()

    if (!disabled) {
      onClose()
      if (onClick) {
        onClick(event, href)
      }
    }
  }

  return (
    <Root
      type={Root === 'button' ? 'button' : undefined}
      {...props}
      className={cn('ContextMenuLink', {[`size-${size}`]: !!size, disabled}, className)}
      href={href}
      aria-disabled={disabled}
      onClick={handleClick}
    >
      {children}
    </Root>
  )
}

export default ContextMenuLink
